import I18n from 'I18n';
import { getFormattedMessageWithObjectTypeName } from 'automation-ui-i18n/i18nUtils';
import { ONE_TO_ONE } from 'automation-ui-associations/constants/AssociationCardinality';
const getAssociationLabel = ({
  associationDefinition,
  toObjectTypeDefinition,
  allAssociatedObjectsLangKey = 'automation-ui-associations.flexible-associations.default-label_cob'
}) => {
  if (!associationDefinition) {
    return '';
  }
  if (associationDefinition.hasAllAssociatedObjects) {
    return getFormattedMessageWithObjectTypeName({
      baseLangKey: allAssociatedObjectsLangKey,
      objectTypeId: associationDefinition.toObjectTypeId,
      objectTypeDefinition: toObjectTypeDefinition
    });
  }
  if (associationDefinition.isPrimary) {
    return I18n.text('automation-ui-associations.flexible-associations.primary-label');
  }
  if (!associationDefinition.label) {
    if (associationDefinition.isInversePrimary) {
      return getFormattedMessageWithObjectTypeName({
        baseLangKey: 'automation-ui-associations.flexible-associations.inverse-primary-label-default_cob',
        objectTypeId: associationDefinition.toObjectTypeId,
        objectTypeDefinition: toObjectTypeDefinition
      });
    } else if (associationDefinition.inverseCardinality === ONE_TO_ONE || associationDefinition.cardinality === ONE_TO_ONE) {
      return getFormattedMessageWithObjectTypeName({
        baseLangKey: 'automation-ui-associations.flexible-associations.default-one-to-one-label_cob',
        objectTypeId: associationDefinition.toObjectTypeId,
        objectTypeDefinition: toObjectTypeDefinition
      });
    } else {
      return getFormattedMessageWithObjectTypeName({
        baseLangKey: 'automation-ui-associations.flexible-associations.default-all-else-failed_cob',
        objectTypeId: associationDefinition.toObjectTypeId,
        objectTypeDefinition: toObjectTypeDefinition
      });
    }
  }
  return associationDefinition.label;
};
export default getAssociationLabel;